var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 32,
    fill: "#FFF",
    opacity: 0.056,
    stroke: "#FFF",
    strokeWidth: 3,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.123 38.274c-.346.446-.706.881-1.09 1.301a21.687 21.687 0 0 1-29.642 2.288 21.65 21.65 0 0 1-3.515-3.587c.75-4.507 4.246-8.131 11.738-9.271 1.57 1.208 3.413 1.903 5.385 1.903 1.973 0 3.817-.696 5.386-1.902 7.492 1.138 10.988 4.762 11.738 9.268zm-9.338-19.078a7.786 7.786 0 1 1-7.786-7.787c4.3 0 7.786 3.486 7.786 7.787zM25 50a24.745 24.745 0 0 0 15.689-5.53 25.239 25.239 0 0 0 2.81-2.647c9.287-10.218 8.533-26.032-1.684-35.321C31.6-2.787 15.788-2.033 6.5 8.186c-9.286 10.219-8.532 26.033 1.685 35.322A25.074 25.074 0 0 0 25 50zm-.002-1.351a23.407 23.407 0 0 0 14.84-5.232 23.875 23.875 0 0 0 2.66-2.503c8.784-9.666 8.071-24.625-1.594-33.412C31.24-1.285 16.284-.572 7.498 9.095-1.287 18.76-.573 33.72 9.091 42.508a23.718 23.718 0 0 0 15.906 6.14z",
    fill: "#FFF",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f792f15a16e437752ad43be1d95bf9ab.svg";
export { ForwardRef as ReactComponent };